import axios from "axios";
import { getUrlApi } from "../utils/util";

class SaleOrderService {
    async getById(orderId) {
        var url = `${await getUrlApi()}/saleorder`;
        return axios.get(`${url}/${orderId}`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async getSaleOrders(first, rows) {
        var url = `${await getUrlApi()}/saleorders`;
        return axios.get(`${url}?first=${first}&rows=${rows}`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }
}

export default new SaleOrderService();
